export class SearchValueTooShortError extends Error {
  constructor(message = 'Search value too short') {
    super(message);
    this.name = 'SearchValueTooShortError';
  }
}
